<template>
  <section class="text-component fade-up" v-in-viewport.once>
    <div
      class="main-content"
      :class="[
        {
          background: _.includes(_.get(contentData, 'conf.conf'), 'background'),
        },
      ]"
    >
      <div class="container-2">
        <h2
          style="margin-bottom: 55px;"
          :class="
            _.includes(_.get(this.contentData, 'conf.conf'), 'strong-title') ? 'font-55' : 'font-34'
          "
          v-if="!_.includes(_.get(contentData, 'conf.conf'), 'no-title')"
        >
          {{ _.get(contentData, 'data.list[0].title') }}
        </h2>
        <videoBlock :url="getvideoURL.url" v-if="getvideoURL.pos === 'top'" />
      </div>

      <div
        class="expanded-container "
        v-if="
          _.get(contentData, 'data.list[0].images[0].devices') &&
            !_.includes(_.get(contentData, 'conf.conf'), 'no-img')
        "
      >
        <div class="img-box">
          <picture>
            <source
              class="img-absolute scale"
              media="(max-width: 767px)"
              :srcset="_.get(contentData, 'data.list[0].images[0].devices.mobile')"
            />
            <source
              class="img-absolute scale"
              media="(max-width: 1023px)"
              :srcset="_.get(contentData, 'data.list[0].images[0].devices.tablet')"
            />
            <img
              class="img-absolute scale"
              :src="_.get(contentData, 'data.list[0].images[0].devices.desktop')"
              :alt="_.get(contentData, 'data.list[0].images[0].title.title')"
            />
          </picture>
        </div>
      </div>
      <div class="container-2">
        <div
          v-if="hasText"
          class="text"
          :class="_.get(contentData, 'data.list[0].files') ? 'files' : ''"
          v-html="
            _.get(contentData, 'data.list[0].content.tabs[0].content') ||
              _.get(contentData, 'data.list[0].content')
          "
        ></div>
        <videoBlock :url="getvideoURL.url" v-if="getvideoURL.pos === 'bottom'" />
        <template v-for="(item, index) in _.get(contentData, 'data.list[0].files')">
          <div
            class="file-download"
            :key="index"
            v-if="
              _.includes(_.get(contentData, 'conf.conf'), 'have-file') ||
                (_.get($store.state.main.selected_menu, 'routeParams.singleview') &&
                  !_.get(contentData, 'data.list[0].relations_data'))
            "
          >
            <p class="font-16 title">{{ item.title }}</p>
            <div class="download-buttons">
              <div class="download-box pointer" @click="downloadItem(item)">
                <IconComponent name="download-arrow" />
                <p class="download-lang">{{ $fn.tr('Download') }}</p>
              </div>
            </div>
          </div>
        </template>
        <div
          class="bottom-cont"
          v-if="
            _.get($store.state.main.selected_menu, 'routeParams.singleview') &&
              !_.includes(_.get(contentData, 'conf.conf'), 'no-back')
          "
        >
          <div class="share-with-friends container-2">
            <p class="font-16">{{ $fn.tr('Share With Friend') }}</p>
            <div class="share-box" key="share-options">
              <div
                :key="index"
                target="_blank"
                :href="icon.url"
                v-html="icon.svg"
                class="share-icon pointer"
                @click.stop="openSharePopup(icon.url)"
                v-for="(icon, index) in getShareLinks"
              ></div>
            </div>
          </div>
          <button class="back" @click="back">
            <div class="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14.841"
                height="14"
                viewBox="0 0 14.841 14"
              >
                <path
                  id="Icon_ionic-md-arrow-round-back"
                  data-name="Icon ionic-md-arrow-round-back"
                  d="M6.911,11.98h9.025l-3.5-3.349a1.4,1.4,0,0,1,0-1.906,1.247,1.247,0,0,1,1.822,0l5.829,5.651a1.285,1.285,0,0,1,.38.945v.017a1.285,1.285,0,0,1-.38.945l-5.824,5.651a1.247,1.247,0,0,1-1.822,0,1.4,1.4,0,0,1,0-1.906l3.5-3.349H6.916a1.32,1.32,0,0,1-1.291-1.35A1.306,1.306,0,0,1,6.911,11.98Z"
                  transform="translate(-5.625 -6.33)"
                  fill="#0d1317"
                />
              </svg>
            </div>
            <p class="font-21">{{ $fn.tr('Back') }}</p>
          </button>
        </div>
      </div>
      <div
        class="container-2"
        v-if="_.includes(_.get(contentData, 'conf.conf'), 'register-banner')"
      >
        <div class="register-banner">
          <div class="left-content">
            <p class="font-34 text-overflow-hidden-3">
              {{ bannerData.title }}
            </p>
            <a :href="bannerData.url.url" target="_blank" class="register-button desktop pointer">
              {{ bannerData.url.title }}
            </a>
          </div>
          <div class="register-img-box" @click="link">
            <picture>
              <img
                class="img-absolute scale"
                :src="_.get(bannerData, 'image[0].url')"
                :alt="_.get(bannerData, 'image[0].title.title')"
              />
            </picture>
          </div>
          <div class="left-content">
            <a :href="bannerData.url.url" target="_blank" class="register-button mobile pointer">
              {{ bannerData.url.title }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div
      id="announcement-grid"
      class="background"
      :class="[
        {
          gray: _.includes(_.get(contentData, 'conf.conf'), 'gray'),
        },
      ]"
    >
      <div
        class="container-2 text-compopent inner-text-events"
        :class="[
          {
            background: _.includes(_.get(contentData, 'conf.conf'), 'announcement-grey'),
          },
        ]"
        v-if="eventsArr && _.includes(_.get(contentData, 'conf.conf'), 'announcement-show')"
      >
        <div class="grid">
          <router-link
            v-for="(item, index) in eventsArr"
            tag="a"
            :to="$store.getters['main/getSingleUrl'](item)"
            class="event-info fade-up"
            v-in-viewport.once
            :key="index"
          >
            <h3 class="font-21 text-overflow-hidden-2">
              {{ item.title }}
            </h3>

            <div class="publish-date">
              {{ $fn.tr('Published:') }} {{ item.date | moment('DD/M/YYYY') }}
            </div>
          </router-link>
        </div>
      </div>
      <center v-if="eventsArr && _.includes(_.get(contentData, 'conf.conf'), 'announcement-show')">
        <el-pagination
          class="pagination"
          background
          layout="prev, pager, next"
          :page-size="per_page_count"
          :current-page.sync="page"
          :total="list_count"
          :disabled="false"
          :hide-on-single-page="true"
          @current-change="getEventsData(true)"
          :key="'pagination'"
        >
        </el-pagination>
      </center>
    </div>
  </section>
</template>

<script>
import EventCard from '../cards/EventsCard.vue';
import IconComponent from '../IconComponent.vue';
import videoBlock from '../videoBlock.vue';
import fn from '../../helpers/func';
import newsItem from '../list/news_and_announcement_item.vue';

export default {
  props: ['contentData'],
  components: {
    newsItem,
    EventCard,
    videoBlock,
    IconComponent,
  },
  data() {
    return {
      page: 1,
      eventsArr: [],
      _list_count: null,
    };
  },
  computed: {
    getvideoURL() {
      var data = {
        url: _.get(this.contentData, 'data.list.0.video_url'),
        pos: _.get(this.contentData, 'data.list.0.video_position'),
      };
      return data;
    },
    getShareLinks() {
      let socialList = [];

      let socialSvgs = _.get(this.$store.state.main.indx, 'widgets.social_icons');

      let uri = encodeURI(
        window.location.protocol +
          '//' +
          window.location.host +
          '' +
          this.$route.path +
          window.location.search
      );

      if (!socialSvgs) return socialList;
      for (let i in socialSvgs) {
        socialList.push({
          svg: _.get(socialSvgs[i], 'svg'),
          url: _.get(socialSvgs[i], 'url') + uri,
        });
      }

      return socialList;
    },
    bannerData() {
      let data = _.get(this.$store.state.main.indx, 'widgets.register_banner');

      return {
        title: data.title,
        image: data.image,
        buttonTitle: data?.button?.title,
        url: data?.url,
      };
    },
    hasText() {
      if (_.get(this.contentData, 'data.list[0].content.tabs[0]')) {
        return true;
      } else if (
        _.get(this.contentData, 'data.list[0].content') &&
        _.get(this.contentData, 'data.list[0].content.tabs.length') != 0
      ) {
        return true;
      } else {
        return false;
      }
    },
    per_page_count() {
      return 12;
    },
    list_count() {
      if (this.eventsArr) {
        return this._list_count;
      }
    },
  },
  methods: {
    link() {
      if (window.innerWidth < 1024) {
        window.location = _.get(this.bannerData, 'url.url');
      }
    },

    async getEventsData(condition) {
      let params;
      params = {
        contentType: 'announcements',
        pageNumber: this.page,
        perPage: this.per_page_count,
        taxonomies: {
          announce_category: [_.get(this.contentData, 'data.list[0].announce_category[0]')],
        },
      };
      let res = await fn.postData('main/getDataList', params);

      condition
        ? document.getElementById('announcement-grid').scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest',
          })
        : '';
      if (_.get(res, 'data')) {
        this.eventsArr = res.data.list;
        this._list_count = res.data.listCount;
      }
    },
    downloadItem(val) {
      window.open(_.get(val, 'url'), '_blank');
    },
    back() {
      if (this.$route.fullPath?.includes('singleview')) {
        if (this.$route.params.path2 == 'singleview') {
          window.location = `/${_.get(this.$store.state.main, 'indx.locale')}/${
            this.$route.params.path1
          }`;
        } else {
          window.location = `/${_.get(this.$store.state.main, 'indx.locale')}/${
            this.$route.params.path1
          }/${this.$route.params.path2}`;
        }
      }
    },
    openSharePopup(url) {
      let winWidth = 650;
      let winHeight = 350;
      let winTop = 200;
      let winLeft = screen.width / 2 - winWidth / 2;
      window.open(
        url,
        'sharer',
        'top=' +
          winTop +
          ',left=' +
          winLeft +
          ',toolbar=0,status=0,width=' +
          winWidth +
          ',height=' +
          winHeight
      );
    },
  },

  mounted() {
    this.getEventsData(false);
  },
};
</script>

<style lang="scss">
.text-component {
  .text {
    line-height: 31px;
  }
  .background {
    &.gray {
      background-color: var(--thirdy-tranparent);
      padding-bottom: 55px;
    }
  }
  .bottom-cont {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #c8c9ca;
    @media (max-width: 1280px) {
      display: none;
    }
    .back {
      display: flex;
      cursor: pointer;
      background: none;
      align-items: center;
      justify-content: center;
      p {
        color: #ababab;
      }
      .icon {
        margin-right: 10px;
        transform: rotate(-180deg);
      }
    }
  }
  .text {
    img {
      height: auto;

      &:not(.image-align-left) {
        width: 72vw;
        margin-left: -5vw;
        // @media (max-width: 1859px) {
        //   max-width: 110%;
        // }
        @media (max-width: 1759px) {
          margin-left: -3vw;
        }
        @media (max-width: 1630px) {
          margin-left: -1vw;
        }
        @media (max-width: 1590px) {
          margin-left: -7vw;
        }

        @media (max-width: 1366px) {
          margin-left: -12vw;
        }
        @media (max-width: 1109px) {
          margin-left: 0;
          width: 100%;
        }
      }

      // @media (max-width: 1859px) {
      //   max-width: 110%;
      // }
      // @media (max-width: 1759px) {
      //   max-width: 105%;
      //   margin-left: -50px;
      // }
      // @media (max-width: 1630px) {
      //   margin-left: -120px;
      //   max-width: 130%;
      // }
      // @media (max-width: 1366px) {
      //   margin-left: -120px;
      //   max-width: 150%;
      // }
      @media (max-width: 1023px) {
        margin-left: 0px;
        max-width: 100%;
      }
    }
    .image-align-left {
      max-width: 100% !important;
      margin-left: 0 !important;
    }
  }
  .text p {
    margin-bottom: 30px;
  }
  .main-content {
    padding: 55px 0 34px;
    @media (max-width: 1439px) {
      padding-top: 30px !important;
    }
    @media (max-width: 1365px) {
      padding: 0px;
    }
    &.background {
      background: var(--thirdy-tranparent);
    }
    &.aditionalPadding {
      padding: 130px 0 300px;
      @media (max-width: 767px) {
        padding: 55px 0 55px;
      }
    }
    h2 {
      color: var(--bonus-txt);
      width: fit-content;
      @media (max-width: 767px) {
        word-break: break-word;
      }
    }
    // .text {
    //   margin-top: 55px;
    // }
    .share-with-friends {
      display: flex;
      align-items: center;
      margin: 55px 0;
      p {
        color: var(--bonus-txt);
      }
      .share-box {
        display: flex;
        .share-icon {
          margin-left: 10px;
        }
      }
    }
    .files {
      margin-bottom: 55px;
    }
    .file-download {
      background: var(--white-bg);
      padding: 30px 60px 30px 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
      position: relative;
      @media (max-width: 1365px) {
        padding: 30px 20px;
      }
      @media (max-width: 1023px) {
        flex-direction: column;
        align-items: flex-start;
        padding: 15px 20px;
      }
      &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: -30px;
        max-height: 25px;
        height: 100%;
        width: 2px;
        border-radius: 5px;
        background: var(--red);
        transform: translateY(-50%);
        transition: 0.4s ease-in-out;
        @media (max-width: 1023px) {
          display: none;
        }
      }
      &:not(:last-child) {
        margin-bottom: 20px;
      }
      p {
        color: var(--bonus-txt);
      }
      .title {
        max-width: 70%;
        margin-right: 30px;
        @media (max-width: 1023px) {
          max-width: 100%;
          margin-right: 0;
          margin-bottom: 20px;
        }
      }
      .download-buttons {
        display: flex;
        align-items: center;
        .download-box {
          display: flex;
          align-items: center;
          color: var(--bonus-txt);
          &.disabled {
            opacity: 0.3;
            pointer-events: none;
            cursor: not-allowed;
          }
          &:not(:last-child) {
            margin-right: 55px;
          }
          .download-lang {
            text-decoration: underline;
            text-decoration-color: var(--bonus-txt);
          }
          svg {
            margin-right: 10px;
          }
        }
      }
      &:hover {
        background: var(--secondary);
        &::before {
          content: '';
          max-height: 150px;
          background: var(--secondary);
          transition: 0.4s ease-in-out;
        }
        p {
          color: var(--white-txt);
        }
        .download-buttons {
          .download-box {
            .download-lang {
              text-decoration: underline;
              text-decoration-color: var(--white-txt);
            }
            svg {
              path {
                fill: var(--white-txt) !important;
              }
            }
          }
        }
      }
    }
    .img-box {
      width: 100%;
      height: 610px;
      margin-top: 55px;
      margin-bottom: 89px;
      position: relative;
      // transform: translateY(-30px);
      @media (max-width: 1599px) {
        height: 464px;
      }
      @media (max-width: 1439px) {
        height: 439px;
        margin-top: 55px;
        margin-bottom: 55px;
      }
      @media (max-width: 1365px) {
        height: 312px;
      }
      @media (max-width: 1023px) {
        // transform: translateY(0);
        // margin-top: 55px;
        height: 375px;
      }
      img {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .register-banner {
      margin-top: 55px;
      background: var(--register-banner);
      border: 1px solid var(--secondary-txt);
      padding: 23px 26px 23px 50px;
      height: 216px;
      display: flex;
      align-items: center;
      @media (max-width: 1439px) {
        height: auto;
      }
      @media (max-width: 1365px) {
        padding: 25px;
      }
      @media (max-width: 833px) {
        flex-direction: column;
      }
      .left-content {
        // margin-right: 30px;
        @media (max-width: 833px) {
          max-width: 100%;
          width: 100%;
          margin-right: 0;
        }
        p {
          color: var(--white-txt);
          margin-bottom: 15px;
          @media (max-width: 833px) {
            margin-bottom: 0;
          }
        }
        .register-button {
          width: fit-content;
          @media (max-width: 833px) {
            width: 100%;
          }
          @include defBut(
            var(--primay-button-bg),
            var(--bonus-txt3),
            var(--secondarty-transparent),
            var(--white-button-txt2)
          );
        }
        .desktop {
          @media (max-width: 833px) {
            display: none;
          }
        }
        .mobile {
          display: none;
          @media (max-width: 833px) {
            display: flex;
            margin-top: 25px;
          }
        }
      }
      .register-img-box {
        // max-width: calc(70% - 15px);
        height: 169px;
        width: 100%;
        position: relative;
        @media (max-width: 833px) {
          margin-top: 25px;
          max-width: 100%;
          width: 100%;
          margin-right: 0;
        }
        .img-absolute {
          position: absolute;
          top: 0%;
          left: 0%;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
    .text-announcement-main {
      .announcement-header-section {
        width: 100%;
        display: flex;
        padding-left: 0px;
        padding-right: 0px;
        align-items: center;
        padding-bottom: 18px;
        justify-content: space-between;
        border-bottom: 1px solid var(--red);
        h3 {
          margin-right: 20px;
          color: var(--bonus-txt);
        }
        .icon-main {
          width: 40px;
          height: 40px;
          display: flex;
          cursor: pointer;
          align-items: center;
          justify-content: center;
          .icon {
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
      .announcement-content {
        display: flex;
        flex-wrap: wrap;
      }
    }
  }

  .list-container {
    transform: translateY(-80px);

    @media (max-width: 767px) {
      transform: translateY(0px);
      padding: 0 10px;
    }
  }
  .events-cards {
    .text-compopent {
      padding: 0;
    }
  }
}

.inner-text-events {
  padding-top: 55px;
  &.announcement-grey {
    background-color: var(--thirdy-tranparent);
  }
  .grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    row-gap: 55px;
    column-gap: 30px;
    @media (max-width: 1365px) {
      row-gap: 34px;
      column-gap: 35px;
    }
    @media (max-width: 1023px) {
      grid-template-columns: repeat(1, minmax(0, 1fr));
      row-gap: 55px;
    }
    .event-info {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .img-box {
        position: relative;
        padding-top: 53%;
        .img-absolute {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      h3 {
        margin-bottom: 17px;
        line-height: 28px;
        color: var(--bonus-txt);
        text-decoration: underline;
        text-decoration-color: var(--bonus-txt);
        @media (max-width: 1365px) {
          margin: 21px 0;
          line-height: 31px;
          font-size: 21px;
        }
        @media (max-width: 1023px) {
          margin: 34px 0;
          line-height: 41px;
          font-size: 34px;
        }
        @media (max-width: 767px) {
          margin: 21px 0;
          line-height: 31px;
          font-size: 21px;
        }
      }
      .event-text {
        color: var(--bonus-txt);
        text-decoration: underline;
        text-decoration-color: var(--bonus-txt);
        line-height: 24px;
        max-height: 48px;
        overflow: hidden;
        p {
          font-size: 16px !important;
        }
      }
      .publish-date {
        margin-top: 10px;
        color: #db504a;
        overflow: hidden;
        line-height: 24px;
        padding-bottom: 34px;
        font-size: 16px !important;
        border-bottom: 1px solid #db504a;
      }
    }
  }
}
</style>
